module.exports = __webpack_public_path__ + "assets/img/left-title-open-9a3d785d.png";